export const capitalizeFirstLetter=(word)=>{
    if (!word) {
        return "";
    }
    const lowerCaseWord = word.toLowerCase();
    const capitalizedWord = lowerCaseWord.charAt(0).toUpperCase() + lowerCaseWord.slice(1);
    return capitalizedWord;
}


export const formatTIN = (tin) => { 

        // if (tin.length !== 9) {
        //     throw new Error("TIN must be exactly 9 characters long.");
        // }
        // if (!/^[a-zA-Z0-9]{9}$/.test(tin)) {
        //     throw new Error("TIN must contain only alphanumeric characters.");
        // }
    
        // Insert hyphens after every 3 characters
        let formattedTIN = tin.match(/.{1,3}/g).join('-');
        return formattedTIN;
    
}